var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"initial-of-campaign",style:(_vm.styleObject)},[_vm._v(" "+_vm._s(_vm.campaign_name.substring(0,2))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }